export enum NotificationStatusLookup {
  Unread = 'Unread',
  Read = 'Read',
  Cleared = 'Cleared',
}
